<template>
    <div :class="{'non-modal-container':!isModal}">
        <el-dialog class="room-config-modal" :visible.sync="roomConfigurationSavedVisible" width="35%" append-to-body>
            <span slot="title">Room Configuration</span>
            <p class="text-left"> Room configuration have been successfully saved.</p>
            <span slot="footer" class="dialog-footer dlg-footer">
                <el-button size="small" @click="roomConfigurationSavedVisible = false">Close</el-button>
            </span>
        </el-dialog>
        <el-dialog :visible.sync="addNewFacilitatorVisible" width="35%" append-to-body>
            <span slot="title" class="add-facilitator-email">Add facilitator's email address</span>
            <div>
                <el-form @submit.prevent.native="addFacilitator">
                    <el-input v-model="facilitator.email"></el-input>
                </el-form>
                <div v-if="duplicateEmail" class="duplicate-email">
                    Email already exists
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="addNewFacilitatorVisible = false">Cancel</el-button>
                <el-button type="primary" @click="addFacilitator">Confirm</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="addNewRoomVisible" width="35%" append-to-body>
            <span slot="title" class="add-room-name">Name</span>
            <div>
                <el-form
                    v-loading="newRoomLoading"
                    element-loading-text="Please wait..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)"
                    @submit.prevent.native="showWarningDialog"
                >
                    <el-input v-model="newRoomName"></el-input>
                </el-form>
            </div>
            <p><b>Note:</b> Adding new rooms will impact your billing and are treated as additional subscriptions.</p>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="addNewRoomVisible = false">Cancel</el-button>
                <el-button type="primary" @click="showWarningDialog">Confirm</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="cancelRoomVisible" width="35%" append-to-body>
            <span slot="title">
                <icon name="exclamation-triangle" scale="1" class="exclamation-triangle-icon"></icon>
                Cancel Room
            </span>
            <div>
                <el-form
                    v-loading="loading"
                    element-loading-text="Please wait..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)"
                >
                    <p class="account-room-cancel-text">
                        Are you sure you want to permanently cancel your mainroom {{ this.cancelledRoom.roomName }}? <br />
                        This will only affect your invoices from the start of your next billing period.
                    </p>
                </el-form>
                <span slot="footer" class="account-room-cancel-footer">
                    <el-button size="small" @click="cancelRoomVisible = false">Cancel</el-button>
                    <el-button class="confirm" type="primary" @click="cancelRoom">Confirm</el-button>
                </span>
            </div>
        </el-dialog>

        <el-dialog :visible.sync="changeCardDetailsVisible" width="35%" append-to-body>
            <p class="change-card-title">Change Card Details</p>
            <el-form
                label-position="top"
                label-width="100px"
                v-loading="cardDetailsLoading"
                element-loading-text="Please wait..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)"
            >
                <el-row :gutter="1" class="text-align-left">
                    <el-col :span="18">
                        <label>Card Number</label>
                        <el-form-item>
                            <card-number
                                class="stripe-element card-number"
                                ref="cardNumber"
                                :stripe="stripe"
                                :options="options"
                                @change="number = $event.complete"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <label>CVC</label>
                        <el-form-item>
                            <card-cvc
                                class="stripe-element card-cvc"
                                ref="cardCvc"
                                :stripe="stripe"
                                :options="options"
                                @change="cvc = $event.complete"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="text-align-left">
                    <el-col>
                        <label>Card expiry</label>
                        <el-form-item class="text-align-left">
                            <card-expiry
                                class="stripe-element card-expiry"
                                ref="cardExpiry"
                                :stripe="stripe"
                                :options="options"
                                @change="expiry = $event.complete"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row type="flex" justify="center" style="margin-top:10px;margin-bottom:10px;margin-left:-10%">
                    <el-col :span="6">
                        <el-button type="primary" @click="changeCardDetails">
                            Change card details
                        </el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog :visible.sync="changeCardWarningVisible" width="35%" append-to-body>
            <span slot="title" class="warning-title"> <icon name="exclamation-triangle" scale="1.2"></icon>&nbsp;Warning </span>
            <el-form
                v-loading="loading"
                element-loading-text="Please wait..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)"
            >
                <div>
                    <p class="new-room-warning-first-line" v-if="inTrial">
                        Creating this room has no upfront cost
                    </p>
                    <p class="new-room-warning-first-line" v-else>
                        Creating this room will incur an upfront cost of
                    </p>
                    <p class="new-room-warning-second-line">US${{ parseFloat(newRoomCharge).toFixed(2) }}</p>
                    <p></p>
                    <p class="new-room-warning-third-line" v-if="inTrial">
                        There will be no charge applied.
                    </p>
                    <p class="new-room-warning-third-line" v-else>
                        which will be charged immediately to your saved payment method.
                    </p>
                </div>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="changeCardWarningVisible = false">Cancel</el-button>
                <el-button type="primary" @click="addNewRoom">Confirm</el-button>
            </span>
        </el-dialog>

        <el-dialog :visible.sync="editDomainOpen" width="30%" height="40%" :modalAppendToBody="false">
            <span slot="title">
                Enter allowed domains on seperate lines
            </span>
            <textarea placeholder="enter valid domain names. Ex: example.com" v-model="allowedDomainsInput" rows="10" class="allowedDomainsInput" :class="{'invalid-input': !validateLoginDomains()}"></textarea>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeDomainInputModal();">Close</el-button>
                <el-button type="primary" :disabled="!validateLoginDomains()" @click="updateMainRoomConfig(allowedDomainsInput.split('\n'), currentDomainInputRow, 'allowedLoginDomains'); closeDomainInputModal();">Done</el-button>
            </span>
        </el-dialog>

        <div class="room-management-window--overlay" v-if="isModal && dashboardVisible" @click="hideDashboardVisibiity"></div>
        <div class="room-management-window" :class="{'non-modal': !isModal}" v-if="dashboardVisible">
            <template>
                <img src="../../public/logo.png" alt="logo" style="width: 40%" v-if="!hideLogo" />
                <div
                    class="modal-loading"
                    v-loading="loading"
                    element-loading-text="Please wait..."
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0.0, 0.0, 0.0, 0.0)"
                >
                    <div class="room-management-window--container">
                        <div class="room-management-window__header">
                            <h3 class="window-title">{{ activeTab == "billingview" ? "Billing Details" : "Parent Room Details" }}</h3>
                            <div @click="hideDashboardVisibiity" v-if="isModal">
                                <IconBase :height="24" :width="24" :view-box="`0 0 24 24`" :fill="'#E7E6FA'">
                                    <IconCross />
                                </IconBase>
                            </div>
                        </div>
                        <el-tabs v-model="activeTab" v-if="dashboardData.length !== 0">
                            <el-tab-pane label="Billing Details" name="billingview" v-if="true || accountDetails.cardType">
                                <div class="admin-dashboard-body">
                                    <div class="payment-method">
                                        <el-form label-position="left" label-width="200px">
                                            <div class="account-owner-info">
                                                <el-form-item label="Account Owner">
                                                    <el-input class="input-field" v-model="this.accountDetails.email" readonly></el-input>
                                                </el-form-item>

                                                <el-form-item label="Card Number">
                                                    <el-input class="input-field" v-model="this.accountDetails.cardNumber" readonly></el-input>
                                                </el-form-item>
                                                <el-form-item label="Card Type">
                                                    <el-input class="input-field" v-model="this.accountDetails.cardType" readonly></el-input>
                                                </el-form-item>

                                                <el-form-item label="Next billing period">
                                                    <el-input class="input-field" v-model="this.accountDetails.nextBillingPeriod" readonly></el-input>
                                                </el-form-item>
                                                <el-form-item label="Plan type">
                                                    <el-input class="input-field" v-model="this.accountDetails.planType" readonly></el-input>
                                                </el-form-item>
                                            </div>
                                        </el-form>
                                    </div>
                                </div>
                            </el-tab-pane>
                            <el-tab-pane label="Room List view" name="listview">
                                <div class="admin-dashboard-body">
                                    <el-table
                                        :data="dashboardData"
                                        style="width: 100%;"
                                        v-if="dashboardData.length !== 0"
                                        header-cell-class-name="admin-dashboard-header-cell"
                                    >
                                        <el-table-column type="expand">
                                         <template slot-scope="props">
                                            <div class="room-configuration">
                                                <div class="switch-container">
                                                    <el-switch 
                                                    inactive-text="Restrict Anonymous Users" 
                                                    v-model="props.row.mainConfig.restrictControlsForAnonymousUsers"
                                                    @change="updateMainRoomConfig($event, props, 'restrictControlsForAnonymousUsers')"
                                                    >
                                                    </el-switch>
                                                    <el-switch 
                                                    inactive-text="Hide Names & Disable Recording"
                                                    v-model="props.row.mainConfig.hideUserNames"
                                                    @change="updateMainRoomConfig($event, props, 'hideUserNames')"
                                                    >
                                                    </el-switch>
                                                    <div id="enableLoginDomainSwitch" role="switch" class="el-switch">
                                                        <el-switch inactive-text="Enable Login Domain"
                                                            v-model="props.row.mainConfig.enableLoginDomains"
                                                            @change="updateMainRoomConfig($event, props, 'enableLoginDomains')">
                                                        </el-switch>
                                                    </div>
                                                </div>
                                            
                                                <div class="btn-container">
                                                    <el-button
                                                        class="confirm"
                                                        type="primary"
                                                        @click="saveRoomConfiguration(props.row.roomName)"
                                                        >
                                                        Save
                                                    </el-button>
                                                </div> 
                                                <span class="info-text">
                                                    Room level settings only apply for new participants after changes are confirmed.
                                                </span>
                                                <span class="editDomain">
                                                    <el-link @click="openDomainInputModal(props);">Edit domains</el-link>
                                                </span>
                                            </div>
                                                <el-table
                                                    :data="props.row.facilitators"
                                                    :default-sort="{
                                                        prop: 'email',
                                                        order: 'ascending',
                                                    }"
                                                    size="small"
                                                    slot="empty"
                                                    empty-text="No data"
                                                    fit
                                                    header-row-class-name="expanded-row-table-header"
                                                    header-cell-class-name="expanded-row-table-header-cell"
                                                    height="300"
                                                >
                                                    <el-table-column
                                                        prop="email"
                                                        label-class-name="label-class"
                                                        label="User"
                                                        sortable
                                                        :sort-method="sortEmail"
                                                        width="200"
                                                    >
                                                    </el-table-column>
                                                    <el-table-column label="Select All" width="80">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox-select-all"
                                                                v-model="props.row.controls['SELECT_ALL']"
                                                                @change="updateAllControls($event, props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Ask for help" width="100">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox-ask-help"
                                                                v-model="props.row.controls['NEED_HELP']"
                                                                @change="updateSelectAll('NEED_HELP', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Create poll" width="90">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox-create-poll"
                                                                v-model="props.row.controls['CREATE_POLL']"
                                                                @change="updateSelectAll('CREATE_POLL', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Broadcast message" width="135">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox-broadcast-message"
                                                                v-model="props.row.controls['BROADCAST_MESSAGE']"
                                                                @change="updateSelectAll('BROADCAST_MESSAGE', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Set timer" width="80">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox-set-timer"
                                                                v-model="props.row.controls['TIMER']"
                                                                @change="updateSelectAll('TIMER', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Add breakout rooms" width="140">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox-set-breakout-rooms"
                                                                v-model="props.row.controls['CREATE_BREAKOUTS']"
                                                                @change="updateSelectAll('CREATE_BREAKOUTS', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Manage rooms" width="135">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox-set-rooms-visibility"
                                                                v-model="props.row.controls['BREAKOUTS_VISIBILITY']"
                                                                @change="updateSelectAll('BREAKOUTS_VISIBILITY', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Return all to lobby" width="135">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox-return-to-lobby"
                                                                v-model="props.row.controls['FORCE_TO_LOBBY']"
                                                                @change="updateSelectAll('FORCE_TO_LOBBY', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Create shared link" width="135">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox-shared-link"
                                                                v-model="props.row.controls['WHITEBOARD']"
                                                                @change="updateSelectAll('WHITEBOARD', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Secure rooms" width="110">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox-add-password"
                                                                v-model="props.row.controls['ADD_PASSWORD_LOCK']"
                                                                @change="updateSelectAll('ADD_PASSWORD_LOCK', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Unlock rooms" width="135">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox"
                                                                v-model="props.row.controls['UNLOCK_ROOMS']"
                                                                @change="updateSelectAll('UNLOCK_ROOMS', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Search participants" width="150">
                                                        <template slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox"
                                                                v-model="props.row.controls['SEE_PARTICIPANTS_NAMES']"
                                                                @change="updateSelectAll('SEE_PARTICIPANTS_NAMES', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="Can record and stream" width="150">
                                                        <template v-if="props.row.email != 'everyone'" slot-scope="props">
                                                            <el-checkbox
                                                                class="checkbox"
                                                                v-model="props.row.controls['CAN_RECORD_VIDEO']"
                                                                @change="updateSelectAll('CAN_RECORD_VIDEO', props.row)"
                                                            />
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column label="" width="80" class-name="delete-facilitator-cell">
                                                        <template slot-scope="propsFacilitator">
                                                            <el-button
                                                                size="small"
                                                                class="delete-facilitator-icon"
                                                                @click="deleteFacilitator(propsFacilitator.row.email, props.row.roomName, propsFacilitator.row.isLoginDomain)"
                                                            >
                                                                <icon name="trash-alt" scale="0.8"></icon>
                                                            </el-button>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                                <div class="new-facilitator-save">
                                                    <el-button class="row-button" size="mini" @click="createNewFacilitator(props.row.roomName)"
                                                        >Add Facilitator</el-button
                                                    >
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column label="Name" prop="roomName" v-if="dashboardData.length !== 0"> </el-table-column>
                                        <el-table-column width="300" label="ID" prop="roomID" v-if="dashboardData.length !== 0"> </el-table-column>
                                        <el-table-column width="100">
                                            <template slot-scope="props">
                                                <el-button size="small" type="text" @click="resetOrRandomiseID(props.row.roomName, 'RESET')"
                                                    >Reset ID</el-button
                                                >
                                            </template>
                                        </el-table-column>
                                        <el-table-column width="100">
                                            <template slot-scope="props">
                                                <el-button size="small" type="text" @click="resetOrRandomiseID(props.row.roomName, 'RANDOMISE')"
                                                    >Randomise ID</el-button
                                                >
                                            </template>
                                        </el-table-column>
                                        <el-table-column>
                                            <template slot-scope="props">
                                                <el-row type="flex" justify="end" class="room-controls">
                                                    <div @click="unlockAndRemovePasswordAllRooms(props.row.roomName)" class="icon-container">
                                                        <IconBase
                                                            :width="15"
                                                            :height="15"
                                                            :view-box="`0 0 24 24`"
                                                            :title="'Unlock all rooms'"
                                                            :fill="'#3887FE'"
                                                            ><icon-open-lock
                                                        /></IconBase>
                                                    </div>
                                                    <div @click="roomCancellationRequest(props.row.roomName)" class="icon-container">
                                                        <IconBase :width="15" :height="15" :view-box="`0 0 24 24`" :title="'Delete'" :fill="'#3887FE'"
                                                            ><icon-bin
                                                        /></IconBase>
                                                    </div>
                                                </el-row>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                        <el-row
                            class="admin-dashboard-body admin-dashboard-body-empty-text"
                            v-else-if="dashboardData.length === 0 && !loading"
                            align="middle"
                            type="flex"
                            justify="center"
                        >
                            <div class="empty-text">
                                You don't currently own any rooms. If you'd like to create your own room please register via our registration link.
                            </div>
                        </el-row>
                        <div class="room-management-window__footer">
                            <div class="footer__left">
                                <el-button size="small" @click="addNewRoomVisible = true" v-if="activeTab == 'listview' && dashboardData.length !== 0"
                                    >Add parent room</el-button
                                >
                                <el-button size="small" @click="registerNow" v-if="dashboardData.length === 0 && !loading">Register Now</el-button>
                                <el-button size="small" v-if="activeTab == 'billingview' && !loading"
                                    ><a
                                        class="anchor-tag"
                                        href="mailto:info@berst.io?subject=Berst.io Support Request"
                                        target="_blank"
                                        >Contact support</a
                                    >
                                </el-button>
                            </div>
                            <div class="footer__right">
                                <el-button class="cancel close-admin" type="default" @click="hideDashboardVisibiity" v-if="isModal">Close</el-button>
                                <el-button
                                    v-if="activeTab == 'listview' && dashboardData.length !== 0"
                                    class="confirm"
                                    type="primary"
                                    @click="saveUpdatedFacilitator"
                                    >Save facilitator permissions</el-button
                                >
                                <el-button
                                    v-else-if="activeTab == 'billingview'"
                                    class="confirm"
                                    type="primary"
                                    @click="changeCardDetailsVisible = true"
                                    >Change payment method</el-button
                                >
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import Icon from "vue-awesome/components/Icon";
import IconBase from "../components/IconBase";
import IconBin from "../components/icons/IconBin";
import IconOpenLock from "../components/icons/IconOpenLock";
import IconCross from "../components/icons/IconCross";
import axios from "../client";
import { showMessage } from "../utils";
import { mapState } from "vuex";
import moment from "moment";
import { createToken, CardNumber, CardExpiry, CardCvc } from "vue-stripe-elements-plus";
import { getMainRoomConfiguration, updateMainRoomConfiguration } from "../api/configuration";


export default {
    name: "AdminDashboard",
    components: {
        Icon,
        IconBase,
        IconBin,
        IconOpenLock,
        IconCross,
        CardNumber,
        CardExpiry,
        CardCvc
    },
    props: ["hideLogo", "dashboardVisible","isModal"],
    data() {
        return {
            activeTab: "listview",
            expandedRooms: [],
            dashboardData: [],
            controlsName: [
                "SELECT_ALL",
                "NEED_HELP",
                "CREATE_POLL",
                "BROADCAST_MESSAGE",
                "TIMER",
                "CREATE_BREAKOUTS",
                "BREAKOUTS_VISIBILITY",
                "FORCE_TO_LOBBY",
                "WHITEBOARD",
                "ADD_PASSWORD_LOCK",
                "LOCK_ROOM",
                "UNLOCK_ROOMS",
                "SEE_PARTICIPANTS_NAMES",
                "CAN_RECORD_VIDEO"
            ],
            addNewFacilitatorVisible: false,
            roomConfigurationSavedVisible: false,
            addNewRoomVisible: false,
            changeCardWarningVisible: false,
            changeCardDetailsVisible: false,
            newRoomName: "",
            facilitator: {
                email: "",
                roomName: "",
            },
            duplicateEmail: false,
            cancelRoomVisible: false,
            cancelledRoom: {
                roomName: "",
            },
            accountDetails: {
                cardNumber: "",
                cardType: "",
                nextBillingPeriod: "",
                planType: "",
                email: "",
            },
            dashboardDataExists: true,
            cardDetailsLoading: false,
            newRoomLoading: false,
            newRoomCharge: false,
            inTrial: false,
            stripe: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
            complete: false,
            number: false,
            expiry: false,
            cvc: false,
            options: {},
            editDomainOpen: false,
            allowedDomainsInput: "",
            currentDomainInputRow: null,
            form: {
                planType: "Monthly Plan",
            },
            rules: {
                planType: [
                    {
                        required: true,
                        message: "Please check on of the value",
                        trigger: ["change", "blur"],
                    },
                ],
            },
        };
    },
    async mounted(){
        await this.getDashboardData();
    },
    watch:{
        async dashboardVisible(newVal){
            if(newVal){
                this.getDashboardData();
            }
        }
    },
    methods: {
        hideDashboardVisibiity() {
            this.$emit("onChangeVisibility", false);
        },
        async refreshSession() {
            this.$store.dispatch("user/refreshTokens", this.getDashboardData);
        },
        async getDashboardData() {
            try {
                this.$store.commit("user/setAuthLoading", true);
                const response = await axios.get("/api/facilitator/admin/dashboard");
                this.dashboardData =  await Promise.all(response.data.dashboardData.map(async (room) => {
                    const mainRoomConfig = await getMainRoomConfiguration(room.roomName);
                    return {
                        roomName: room.roomName,
                        roomID: room.roomID,
                        mainConfig: mainRoomConfig.data,
                        facilitators: room.facilitators
                            ? room.facilitators.map((facilitator) => {
                                  const controls = {
                                      NEED_HELP: false,
                                      LAST_N: false,
                                      CREATE_BREAKOUTS: false,
                                      BREAKOUTS_VISIBILITY: false,
                                      TIMER: false,
                                      WHITEBOARD: false,
                                      FORCE_TO_LOBBY: false,
                                      CREATE_POLL: false,
                                      BROADCAST_MESSAGE: false,
                                      ADD_PASSWORD_LOCK: false,
                                      UNLOCK_ROOMS: false,
                                      SEE_PARTICIPANTS_NAMES: false,
                                      CAN_RECORD_VIDEO: false,
                                      SELECT_ALL: false,
                                  };
                                  facilitator.controls.forEach((control) => {
                                      controls[control] = true;
                                  });

                                  const facilitatorObj = {
                                      email: facilitator.email,
                                      controls: controls,
                                      isLoginDomain: facilitator.isLoginDomain
                                  };
                                  facilitatorObj.controls["SELECT_ALL"] = this.areAllControlsChecked(facilitatorObj);
                                  return facilitatorObj;
                              })
                            : [],
                    };
                }));
                this.accountDetails = {
                    cardNumber: "************" + response.data.accountDetails.cardNumber,
                    cardType: response.data.accountDetails.cardType,
                    nextBillingPeriod: moment
                        .unix(response.data.accountDetails.nextBillingPeriod)
                        .local()
                        .format("DD-MM-YYYY"),
                    planType: response.data.accountDetails.planType,
                    email: response.data.accountDetails.email,
                };
                if (!this.accountDetails && !this.dashboardData) {
                    this.dashboardDataExists = false;
                }
                this.$store.commit("user/setAuthLoading", false);
            } catch (error) {
                this.$store.commit("user/setAuthLoading", false);
                if (error.response.data.message === "TOKEN_EXPIRED") {
                    this.refreshSession();
                } else {
                    alert("Unauthorized");
                }
            }
        },
        async addNewRoom() {
            try {
                this.$store.commit("user/setAuthLoading", true);
                const controls = {
                    NEED_HELP: true,
                    LAST_N: true,
                    CREATE_BREAKOUTS: true,
                    BREAKOUTS_VISIBILITY: true,
                    TIMER: true,
                    WHITEBOARD: true,
                    FORCE_TO_LOBBY: true,
                    CREATE_POLL: true,
                    BROADCAST_MESSAGE: true,
                    ADD_PASSWORD_LOCK: true,
                    UNLOCK_ROOMS: true,
                    SEE_PARTICIPANTS_NAMES: true,
                    CAN_RECORD_VIDEO: true,
                    SELECT_ALL: true,
                };
                const response = await axios.post("/api/facilitator/registerRoom", {
                    roomName: this.newRoomName,
                });
                const newRoomData = {
                    roomName: response.data.room.name,
                    roomID: response.data.room.urlID,
                    facilitators: [{ email: "everyone", controls: controls }],
                };
                this.dashboardData.push(newRoomData);
                this.changeCardWarningVisible = false;
                this.$store.commit("user/setAuthLoading", false);
                showMessage("Room successfully created", "success");
            } catch (error) {
                this.$store.commit("user/setAuthLoading", false);
                if (error.response.data.message === "TOKEN_EXPIRED") {
                    this.$store.dispatch("user/refreshTokens", this.addNewRoom);
                } else if (error.response.data.message === "Room name already exists") {
                    showMessage("Room name is already taken", "error");
                } else {
                    showMessage("Something went wrong.", "error");
                }
            }
        },
        async saveUpdatedFacilitator() {
            this.$store.commit("user/setAuthLoading", true);
            const bulkUpdateError = await this.bulkUpdateRoom(this.dashboardData);
            if (bulkUpdateError.tokenExpiredError == true) {
                this.$store.dispatch("user/refreshTokens", this.saveUpdatedFacilitator);
            } else if(bulkUpdateError.unauthorized || bulkUpdateError.errorRoomNames.length > 0) {
                this.showUpdateRoomErrorMessage(bulkUpdateError);
                await this.getDashboardData();
            }
            this.$store.commit("user/setAuthLoading", false);
        },
        async bulkUpdateRoom(rooms) {
            let error = {
                unauthorized: false,
                tokenExpiredError: false,
                errorRoomNames: [],
                successRoomName: [],
            };
            for (let roomIndex = 0; roomIndex < rooms.length; roomIndex++) {
                const data = Object.assign({}, rooms[roomIndex]);
                data["facilitators"] = this.getFormattedFacilitators(data.facilitators);
                try {
                    await this.requestFacilitatorUpdateApi(data);
                    error.successRoomName.push(data);
                } catch (err) {
                    if (err.response.data.message === "TOKEN_EXPIRED") {
                        error.tokenExpiredError = true;
                    } else {
                        error.unauthorized = true;
                    }
                    error.errorRoomNames.push(data);
                }
            }
            return error;
        },
        async requestFacilitatorUpdateApi(data) {
            await axios.put("/api/facilitator/update", {
                mainRoom: data.roomName,
                facilitators: data.facilitators,
            });
        },
        openDomainInputModal(props) {
            this.editDomainOpen = true;
            var allowedDomains = props.row.mainConfig.allowedLoginDomains || [];
            this.allowedDomainsInput = allowedDomains.join("\n");
            this.currentDomainInputRow = props;
        },
        closeDomainInputModal() {
            this.editDomainOpen = false;
            this.currentDomainInputRow = null;
        },
        validateLoginDomains() {
            let domainsInput = this.allowedDomainsInput.split("\n").filter(input => input.trim() !== "");
            const domainRegex = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/g;
            var validInput = true;
            for (let index = 0; index < domainsInput.length; index++) {
                if (!domainsInput[index].toLowerCase().match(domainRegex)) {
                    validInput = false;
                    break;
                }
            }
            return validInput;
        },
        getFormattedFacilitators(facilitators) {
            if (facilitators) {
                return facilitators.map((facilitator) => {
                    const controls = [];
                    for (let [key, value] of Object.entries(facilitator.controls)) {
                        if (value === true && key !== "SELECT_ALL") {
                            controls.push(key);
                        }
                    }
                    return {
                        email: facilitator.email,
                        controls: controls,
                    };
                });
            }
            return [];
        },
        showUpdateRoomErrorMessage(errorObj) {
            if (errorObj.unauthorized == true) {
                alert("Unauthorized");
            }
            let errorMessage = "";
            if (errorObj.errorRoomNames.length > 0) {
                errorMessage += `${this.getRoomNameForErrorMessage(errorObj.errorRoomNames.map((e) => e.roomName))}, `;
            }
            if (errorMessage) {
                showMessage(`Could not update ${errorMessage.slice(0, errorMessage.length - 2)}`, "error");
            }
        },
        getRoomNameForErrorMessage(errorRoomNames = []) {
            if (errorRoomNames.length > 2) {
                return `${errorRoomNames.slice(0, 2).toString()} + ${errorRoomNames.slice(2).length} room(s)`;
            }
            return `${errorRoomNames.toString()}`;
        },
        async addFacilitator() {
            try {
                const response = await axios.post("/api/facilitator/", {
                    email: this.facilitator.email,
                    mainRoom: this.facilitator.roomName,
                });
                let foundIndex = this.dashboardData.findIndex((data) => data.roomName === this.facilitator.roomName);
                const controls = {
                    NEED_HELP: false,
                    LAST_N: false,
                    CREATE_BREAKOUTS: false,
                    BREAKOUTS_VISIBILITY: false,
                    TIMER: false,
                    WHITEBOARD: false,
                    FORCE_TO_LOBBY: false,
                    CREATE_POLL: false,
                    BROADCAST_MESSAGE: false,
                    ADD_PASSWORD_LOCK: false,
                    UNLOCK_ROOMS: false,
                    SEE_PARTICIPANTS_NAMES: false,
                    CAN_RECORD_VIDEO: false,
                    SELECT_ALL: false,
                };
                const facilitatorData = {
                    email: this.facilitator.email,
                    mainRoom: this.facilitator.roomName,
                    controls: controls,
                };
                response.data.facilitator.controls.forEach((control) => {
                    controls[control] = true;
                });
                response.data.facilitator.controls = controls;
                this.dashboardData[foundIndex].facilitators.push(facilitatorData);
                this.addNewFacilitatorVisible = false;
            } catch (error) {
                if (error.response.data.message === "TOKEN_EXPIRED") {
                    this.$store.dispatch("user/refreshTokens", this.addFacilitator);
                } else {
                    alert("Unauthorized");
                }
                if (error.response.data.message === "Duplicate email address") {
                    this.duplicateEmail = true;
                } else {
                    showMessage("Could not add facilitator", "error");
                    this.addNewFacilitatorVisible = false;
                }
            }
        },
        createNewFacilitator(roomName) {
            this.facilitator.email = "";
            this.duplicateEmail = false;
            this.addNewFacilitatorVisible = true;
            this.facilitator.roomName = roomName;
        },
        async resetOrRandomiseID(roomName, type) {
            try {
                const response = await axios.put("/api/rooms/" + roomName + "/urlId/", {
                    type: type,
                });
                let foundIndex = this.dashboardData.findIndex((data) => data.roomName === roomName);
                this.dashboardData[foundIndex].roomID = response.data.room.urlID;
            } catch (error) {
                if (error.response.data.message === "TOKEN_EXPIRED") {
                    const callback = () => {
                        this.resetOrRandomiseID(roomName, type);
                    };
                    this.$store.dispatch("user/refreshTokens", callback);
                } else {
                    alert("Unauthorized");
                }
                showMessage(error.message, "error");
            }
        },
        async unlockAndRemovePasswordAllRooms(roomName) {
            try {
                await axios.put("/api/rooms/" + roomName + "/unlock/");
                showMessage("Successfully unlocked all rooms", "success");
            } catch (error) {
                if (error.response.data.message === "TOKEN_EXPIRED") {
                    const callback = () => {
                        this.unlockAndRemovePasswordAllRooms(roomName);
                    };
                    this.$store.dispatch("user/refreshTokens", callback);
                } else {
                    alert("Unauthorized");
                }
                showMessage("Error in unlocking rooms", "error");
                return error;
            }
        },
        updateAllControls(checked, facilitator) {
            this.controlsName.forEach((control) => {
                if (control === "SELECT_ALL")
                    return;

                if (facilitator.email == "everyone" && control == "CAN_RECORD_VIDEO") {
                    return;
                }

                facilitator.controls[control] = checked;
            });
        },
        updateMainRoomConfig(isChecked, props, propertyChanged){
            var row = props.row;
            if (propertyChanged === "enableLoginDomains" && isChecked) {
                this.openDomainInputModal(props);
            }
             let roomChangedIndex = this.dashboardData.findIndex((data) => data.roomName === row.roomName);
             if(roomChangedIndex >= 0){
                this.dashboardData[roomChangedIndex].mainConfig[propertyChanged] = isChecked;
             }
        },
        updateSelectAll(control, facilitator) {
            facilitator.controls["SELECT_ALL"] = this.areAllControlsChecked(facilitator);
        },
        async deleteFacilitator(email, roomName, isLoginDomain) {
            try {
                await axios.delete("/api/facilitator", {
                    data: {
                        mainRoom: roomName,
                        email: email,
                    },
                });
                const room = this.dashboardData.find((data) => data.roomName === roomName);
                let facilitatorIndex = room.facilitators.findIndex((facilitator) => facilitator.email === email);
                room.facilitators.splice(facilitatorIndex, 1);
                if (isLoginDomain) {
                    const allowedDomains = room.mainConfig.allowedLoginDomains;
                    const domainIndex = allowedDomains.indexOf(email);
                    domainIndex > -1 && allowedDomains.splice(domainIndex, 1);
                    room.mainConfig.allowedLoginDomains = allowedDomains;
                }
            } catch (error) {
                if (error.response.data.message === "TOKEN_EXPIRED") {
                    const callback = () => {
                        this.deleleFacilitator(email, roomName);
                    };
                    this.$store.dispatch("user/refreshTokens", callback);
                } else {
                    alert("Unauthorized");
                }
                showMessage("Error in deleting facilitator", "error");
            }
        },
        sortEmail(f1, f2) {
            if (f1.email === "everyone") {
                return -1;
            }
            if (f2.email === "everyone") {
                return 1;
            }
            if (f1.isLoginDomain && f2.isLoginDomain) {
                return f1.email.localeCompare(f2.email);
            }
            if (f1.isLoginDomain && f2.email !== 'everyone') {
                return -1;
            }
            if (f2.isLoginDomain && f1.email !== 'everyone') {
                return 1;
            }
            return f1.email.localeCompare(f2.email);
        },
        roomCancellationRequest(roomName) {
            this.cancelledRoom.roomName = roomName;
            this.cancelRoomVisible = true;
        },
        async cancelRoom() {
            try {
                this.$store.commit("user/setAuthLoading", true);
                await axios.get("/api/rooms/room/cancelSubscription/" + this.cancelledRoom.roomName);
                let index = this.dashboardData.findIndex((data) => data.roomName === this.cancelledRoom.roomName);
                this.dashboardData.splice(index, 1);
                this.cancelledRoom.roomName = "";
                this.cancelRoomVisible = false;
                this.$store.commit("user/setAuthLoading", false);
                showMessage("Room cancelled", "success");
            } catch (err) {
                this.$store.commit("user/setAuthLoading", false);
                if (err.response.data.message === "TOKEN_EXPIRED") {
                    const callback = () => {
                        this.cancelRoom();
                    };
                    this.$store.dispatch("user/refreshTokens", callback);
                }
                showMessage("Could not cancel room", "error");
            }
        },
        registerNow() {
            this.$router.push({
                path: "/register_room",
            });
        },
        update() {
            this.complete = this.number && this.expiry && this.cvc;
            if (this.number) {
                if (!this.expiry) {
                    this.$refs.cardExpiry.focus();
                } else if (!this.cvc) {
                    this.$refs.cardCvc.focus();
                }
            } else if (this.expiry) {
                if (!this.cvc) {
                    this.$refs.cardCvc.focus();
                } else if (!this.number) {
                    this.$refs.cardNumber.focus();
                }
            }
        },
        async changeCardDetails() {
            const data = await createToken();
            try {
                this.cardDetailsLoading = true;
                const response = await axios.put("/api/facilitator/update/card", {
                    data: data,
                    email: this.accountDetails.email,
                });
                this.accountDetails.cardNumber = "************" + response.data.response.last4;
                this.accountDetails.cardType = response.data.response.brand;
                showMessage("Successfully updated your card details", "success");
                this.cardDetailsLoading = false;
                this.changeCardDetailsVisible = false;
            } catch (err) {
                this.cardDetailsLoading = false;
                this.changeCardDetailsVisible = false;
                if (err.response.data.message === "TOKEN_EXPIRED") {
                    this.$store.dispatch("user/refreshTokens", this.changeCardDetails);
                } else {
                    showMessage("Could not update your card details", "error");
                }
            }
        },
        async showWarningDialog() {
            try {
                this.newRoomLoading = true;
                const response = await axios.get("/api/rooms/room/price", {
                    email: this.accountDetails.email,
                });
                this.newRoomCharge = response.data.price;
                this.inTrial = response.data.inTrial;
                this.newRoomLoading = false;
                this.addNewRoomVisible = false;
                this.changeCardWarningVisible = true;
            } catch (error) {
                this.newRoomLoading = false;
                if (error.response.data.message === "TOKEN_EXPIRED") {
                    const callback = () => {
                        this.showWarningDialog();
                    };
                    this.$store.dispatch("user/refreshTokens", callback);
                } else {
                    showMessage("Something went wrong...", "error");
                }
            }
        },
        areAllControlsChecked(facilitator) {
            const anyUncheckedControl = this.controlsName.find((control) => {
                if (facilitator.email === 'everyone' && control === 'CAN_RECORD_VIDEO')
                    return false;
                return facilitator.controls[control] === false && control !== "SELECT_ALL";
            });
            return !anyUncheckedControl;
        },
        async saveRoomConfiguration(roomName) {
            let roomSavedIndex = this.dashboardData.findIndex((data) => data.roomName === roomName);
            try {
                this.$store.commit("user/setAuthLoading", true);
                await updateMainRoomConfiguration(roomName, this.dashboardData[roomSavedIndex].mainConfig);
                await this.getDashboardData();
                if (roomName === localStorage.getItem('mainRoom')) {
                    this.$store.dispatch("user/getControls", roomName);
                }
                this.$store.commit("user/setAuthLoading", false);
                this.roomConfigurationSavedVisible = true;
            } catch (error) {
                if (error.response.data.message === "TOKEN_EXPIRED") {
                    this.$store.dispatch("user/refreshTokens", this.saveRoomConfiguration);
                } else {
                    alert("Unauthorized");
                }
            }
        },
    },
    computed: {
        ...mapState({
            loading: (state) => state.user.authLoading
        }),
    },
};
</script>

<style>
.el-table-column {
    color: pink;
}
</style>
<style scoped>
a {
    color: #606266;
}

.admin-dashboard-body {
    overflow-y: scroll;
}

.checkbox {
    margin-left: 45px;
}
.checkbox-select-all {
    margin-left: 20px;
}
.checkbox-ask-help {
    margin-left: 28px;
}
.checkbox-create-poll {
    margin-left: 28px;
}
.checkbox-broadcast-message {
    margin-left: 45px;
}
.checkbox-set-timer {
    margin-left: 20px;
}
.checkbox-switch-to-expanded {
    margin-left: 45px;
}
.checkbox-set-breakout-rooms {
    margin-left: 45px;
}
.checkbox-set-rooms-visibility {
    margin-left: 50px;
}
.checkbox-return-to-lobby {
    margin-left: 50px;
}
.checkbox-shared-link {
    margin-left: 45px;
}
.checkbox-add-password {
    margin-left: 35px;
}
.checkbox-lock-room {
    margin-left: 20px;
}
.duplicate-email {
    margin-top: 10px;
}

/* .room-data {
    padding-bottom: 30px;
    justify-content: center;
    margin-left: 50px;
    margin-right: 50px;
} */

.form-headers {
    font-weight: bold;
    padding-bottom: 25px;
}

.form-headers-room-facilitators {
    font-size: 2px;
    font-weight: bold;
    width: 10px;
    margin-left: 10px;
}

.room-facilitators {
    border-style: ridge;
    margin-left: 70px;
    margin-right: 50px;
    padding-bottom: 50px;
}

.room-facilitators-content {
    font-size: 10px;
}

.admin-dashboard-footer {
    margin-top: 50px;
}

.col-display-user {
    padding-right: 150px;
    width: 100px;
}

.col-display-control {
    padding-right: 10px;
    padding-left: 30px;
    width: 5px;
}

.delete-facilitator-icon {
    background: none;
    border: none;
    margin-right: 0px;
    margin-left: 0px;
}

.arrow-button {
    background: none;
    border: none;
    margin-right: 0px;
    margin-left: 0px;
}

.el-table-column {
    color: pink;
}

.exclamation-triangle-icon {
    margin-left: 35%;
}

.account-room-cancel-text {
    margin-left: 5%;
    padding-bottom: 10px;
}

.account-room-cancel-footer {
    display: flex;
    justify-content: flex-end;
}

.add-room-name {
    margin-left: 45%;
}

.add-facilitator-email {
    margin-left: 25%;
}

.anchor-tag {
    text-decoration: none;
    color: #e7e6f9;
}

h4 {
    text-align: left;
}

.el-main.el-main-payment {
    margin: 0 auto !important;
    max-width: 600px;
    overflow: hidden;
}

.payment-header {
    font-size: 20px;
    font-weight: 600;
}

.text-align-left {
    text-align: left;
}

.account-owner-info {
    text-align: left;
}

.billing-room-title {
    font-size: 20px;
    font-weight: 600;
    font-style: italic;
}

.change-payment-method {
    margin-left: 58%;
}

.input-field {
    width: 500px;
    left: 10px;
}

.billing-info {
    background: white;
    padding-top: 5px;
    padding-bottom: 10px;
}

.room-details-heading {
    background: white;
    padding-top: 20px;
    padding-bottom: 10px;
    font-size: 20px;
    font-weight: 600;
    font-style: italic;
}

.change-card-title {
    margin-left: 30%;
    margin-top: -10%;
    font-size: 20px;
    font-weight: 600;
    margin-top: -20px;
}

.warning-title {
    display: flex;
    justify-content: center;
}

.new-room-warning-first-line {
    text-align: center;
}

.new-room-warning-second-line {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
}

.new-room-warning-third-line {
    text-align: center;
}

.room-configuration{
    padding: 0px 10px 10px 10px;
    overflow: hidden;
}

.room-configuration .switch-container{
    float: left;
    padding-top: 9px;
}

.room-configuration .btn-container{
    float: right;
}

.room-configuration .info-text{
    display: inline-block;
    margin-right: 180px;
    font-size: 11px;
    margin-left: 15px;
    margin-top: 5px;
}

</style>

<style scoped>
/* Custom styles for element UI */

.new-facilitator-save {
    padding: 10px 0px;
}
button.row-button.el-button,
button.row-button.el-button:hover {
    height: 30px;
    padding: 6px 16px;
    font-size: 14px;
    line-height: 16px;
    border-radius: 6px;
}

.el-table {
    color: #e7e6fa;
}

>>> .room-configuration .el-switch{
    margin: 0px 10px;
}

>>> .room-configuration .el-switch__label.is-active, 
>>> .room-configuration .el-switch__label{
    color:#fff;
    font-weight: 700;
}

>>> .el-table::before {
    background: none;
}
>>> .el-table td,
>>> .el-table th.is-leaf {
    border-bottom: 1px solid #393752;
}

>>> .el-table th,
>>> .el-table tr,
>>> .el-table th:hover,
>>> .el-table tr:hover {
    background-color: #252529;
}

>>> .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #2b2b33 !important;
}

>>> .el-table,
>>> td.el-table__expanded-cell {
    background: rgba(43, 43, 51, 0.23);
}

>>> .el-table__expanded-cell[class*="cell"] {
    padding: 15px 0px 15px 10px;
    border: 1px solid #393752;
}
>>> .el-checkbox__input.is-checked .el-checkbox__inner,
>>> .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #caedf5;
    border-color: #50c6df;
}

>>> span.el-checkbox__inner::after {
    border: 2px solid #000000;
    border-left: 0;
    border-top: 0;
}
.admin-dashboard-body {
    position: relative;
    height: calc(600px - 70px - 48px - 45px);
    overflow-x: auto;
    scroll-behavior: smooth;
}

.admin-dashboard-body::-webkit-scrollbar {
    display: block !important;
    background: transparent;
    width: 6px;
}

.admin-dashboard-body::-webkit-scrollbar-thumb {
    background: #5e5e7a;
    border-radius: 10px;
    width: 6px;
}

.room-management-window--overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vmax;
    background: #000;
    opacity: 0.5;
    z-index: 1;
}
.room-management-window {
    position: fixed;
    background-color: #252529;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    z-index: 19;
    width: 80%;
    min-width: 700px;
    max-width: 900px;
    height: 600px;
    border-radius: 8px;
}

.room-management-window.non-modal{
    position: relative;
    margin: 0px auto;
    padding: 10px 0px;
    width: auto;
    max-width: 100%;
    min-width: auto;
    height: auto;
    background: #1c1d29;
    border: 1px solid #2a2a3d;
}

.room-management-window--container {
    position: relative;
}

.room-management-window__header,
.room-management-window__footer {
    display: flex;
    align-items: center;
    width: calc(100% - 32px);
    background-color: #2b2b33;
    padding: 9px 16px;
}
.non-modal
.room-management-window__header,
.non-modal .room-management-window__footer {
    background: none;
}

.room-management-window__header {
    position: relative;
    justify-content: space-between;
    align-items: flex-start;
    border-radius: 8px 8px 0 0;
    height: calc(70px - 18px);
}

h3.window-title {
    margin: 0;
    font-weight: 600;
    font-size: 18px;
    line-height: 23px;
    color: #ffffff;
}

.room-management-window__footer {
    height: calc(77px - 18px);
    justify-content: space-between;
    border-radius: 0 0 8px 8px;
}
div.el-tabs {
    position: relative;
    top: -23px;
}

>>> div.el-tabs__header {
    margin: 0;
    padding: 0 16px;
    background-color: #2b2b33;
}
>>> .non-modal .el-tabs__header {
    padding: 5px 16px;
    background: none;
}
>>> div.el-tabs__item {
    padding: 0 8px;
    height: 15px;
    font-size: 12px;
    line-height: 15px;
    font-weight: normal;
    color: #e7e6fa;
}

>>> div.el-tabs__nav {
    padding-bottom: 4px;
}

>>> div.el-tabs__item.is-active {
    color: #50c6df;
}

>>> div.el-tabs__active-bar {
    background-color: #50c6df;
}

>>> div.el-tabs__nav-wrap::after {
    background-color: transparent;
}

>>> div.el-tabs__content {
    min-width: 668px;
}

>>> .el-input__prefix {
    left: 10px;
    top: 9px;
}
.icon-container,
.icon-container .icon--disabled {
    margin-left: 10px;
    height: 24px;
    width: 24px;
    background: #3e3e52;
    box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 3px 3px rgba(0, 0, 0, 0.12), 0px 1px 8px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
}
svg {
    margin-bottom: 0px;
}

>>> ..el-dialog__title {
  color: #fff;
}

>>> .el-dialog__header {
  background: #292a33;
  color: #fff;
  text-align: left;
  font-weight: bold;
}
>>> .el-dialog__body,
>>> .el-dialog__footer {
  background: #2b2b33;
  color: #fff;
}

>>> .el-dialog__body {
  background-color: #252529;
}

>>> .el-dialog__footer {
  text-align: left;
}

>>> .el-dialog__footer > span {
  display: flex;
  justify-content: flex-end;
}

>>> .el-table th.expanded-row-table-header-cell {
    padding: 0px;
    background: #2b2c32;
    color: #e7e6fa;
    font-weight: normal;
}
>>> .el-table th.admin-dashboard-header-cell {
    font-weight: 600;
    font-size: 16px;
    color: rgba(255, 255, 255, 0.8);
}

>>> button.el-button.delete-facilitator-icon:active,
button.el-button.delete-facilitator-icon:focus,
button.el-button.delete-facilitator-icon:hover {
    border: none;
    background: none;
    box-shadow: none;
}
>>> label.el-form-item__label {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: rgba(255, 255, 255, 0.8);
    padding: 10px 0 0 16px;
    text-align: left;
}

>>>.el-input__inner{
    color: #fff;
    background-color: #393752;
    border: 1px solid #393752;
    height: 32px;
}

>>> .el-input .el-input__inner {
    padding: 6px;
    height: 34px;
}

>>> .el-input .el-input__inner::-webkit-input-placeholder {
    /* Edge */
    color: #7f7e95;
    font-family: inherit;
}

>>> .el-input .el-input__inner:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #7f7e95;
    font-family: inherit;
}

>>> .el-input .el-input__inner::placeholder {
    color: #7f7e95;
    font-family: inherit;
}

>>> .el-input__inner::placeholder {
    color: #7f7e95;
}

>>> .el-input-number__decrease,
>>> .el-input-number__increase {
    background-color: #393752;
    border: none;
}
.payment-method {
    padding-top: 50px;
}

.el-form-item {
    border-bottom: 1px solid #393752;
    margin-bottom: 0;
    padding: 8px;
}
.empty-text {
    padding: 40px 20px;
    font-weight: 500;
}
.admin-dashboard-body.admin-dashboard-body-empty-text {
    height: calc(600px - 70px - 48px - 45px + 15px);
}
.non-modal .admin-dashboard-body{
    min-height: calc(600px - 70px - 48px + 15px);
    height: unset;
}
.non-modal .room-management-window--container{
    height: unset;
    color: white;
}
.non-modal-container{
    background-color: #1C1C29;
    height: 100vh;
    padding: 20px;
    overflow-y: auto;
}

.card-number{
    background-color: #faffbd;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.card-cvc{
    background-color: #faffbd;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.card-expiry{
    background-color: #faffbd;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

.allowedDomainsInput {
    max-width: 100%;
    max-height: 250px;
    min-width: 100%;
    min-height: 70%;
}
.invalid-input {
    border-color: red;
    outline: 2px solid red;
}

.editDomain a{
    color: #50C6DF;
    display: inline-block;
    font-size: 12px;
    margin-top: 5px;
}

@media (max-width: 767px) {
    .room-management-window{
        min-width: 100%;
        top: 56px;
        left: 0;
        height: auto;
        bottom: 0;
        transform: translate(0, 0);
    }
    .room-management-window .modal-loading{
        height: 100%;
    }
    .room-management-window .room-management-window--container{
        height: 100%;
    }
    >>> div.el-tabs {
        height: calc(100% - 147px);
    }
    >>> div.el-tabs__content{
        height: 100%;
        min-width: initial;
        width: 100%;
    }
    >>> .el-tab-pane{
        height: 100%;
    }
    >>> .admin-dashboard-body{
        height: 100%;
    }
    >>> .el-table{
        height: 100%;
    }
    >>> .el-table__body-wrapper{
        height: calc(100% - 50px);
    }
    >>> .close-admin{
        display: none;
    }
    >>> button.el-button--default, button.el-button--default:hover, button.el-button--default:active,
        button.el-button--primary, button.el-button--primary:hover, button.el-button--primary:active {
        padding: 8px 4px;
        font-size: 13px;
    }
    >>> .room-management-window__footer{
        width: 100%;
        box-sizing: border-box;
        padding: 9px 8px;
    }
}
@media (hover: none) {
    .room-management-window{
        min-width: 100%;
        top: 56px;
        left: 0;
        height: auto;
        bottom: 0;
        transform: translate(0, 0);
    }
    .room-management-window .modal-loading{
        height: 100%;
    }
    .room-management-window .room-management-window--container{
        height: 100%;
    }
    >>> div.el-tabs {
        height: calc(100% - 147px);
    }
    >>> div.el-tabs__content{
        height: 100%;
        min-width: initial;
        width: 100%;
    }
    >>> .el-tab-pane{
        height: 100%;
    }
    >>> .admin-dashboard-body{
        height: 100%;
    }
    >>> .el-table{
        height: 100%;
    }
    >>> .el-table__body-wrapper{
        height: calc(100% - 50px);
    }
    >>> .close-admin{
        display: none;
    }
    >>> button.el-button--default, button.el-button--default:hover, button.el-button--default:active,
        button.el-button--primary, button.el-button--primary:hover, button.el-button--primary:active {
        padding: 8px 4px;
        font-size: 13px;
    }
    >>> .room-management-window__footer{
        width: 100%;
        box-sizing: border-box;
        padding: 9px 8px;
    }
}

</style>
